import { useAuth0 } from '@auth0/auth0-react';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { createGTMTracking, getGTMAttributes } from '../../utils/gtm/gtm-tracking';
import { Button } from '../ui';

interface LoginButtonProps {
  /** Origin for GTM. Pass from parent. */
  origin: 'header' | 'mobile_menu';
}

const customAuthEnabled =
  (import.meta.env.VITE_CUSTOM_AUTH_ENABLED ?? 'true') !== 'false';

/**
 * Routes to the new custom /login page when the feature flag is on
 * (default), or falls back to Auth0 hosted Universal Login otherwise.
 * The fallback exists so we can flip the flag off for a fast rollback
 * without redeploying.
 */
export const LoginButton: React.FC<LoginButtonProps> = ({ origin }) => {
  const { loginWithRedirect } = useAuth0();
  const navigate = useNavigate();

  const handleLogin = async () => {
    if (customAuthEnabled) {
      navigate('/login');
      return;
    }
    await loginWithRedirect({
      appState: { returnTo: '/dashboard' },
      authorizationParams: { prompt: 'login' },
    });
  };

  return (
    <Button
      label="Login"
      type="text"
      intent="secondary"
      className="w-fit"
      onClick={handleLogin}
      {...getGTMAttributes(createGTMTracking('LOGIN', { origin }))}
    />
  );
};
